import { helpers, maxLength, required } from "@vuelidate/validators";
import { validZenkakuKanaForAddress } from "common/src/utils/validate";
import { computed } from "vue";

export const SCR120FormValidateRule = computed(() => ({
  kei01p: {
    tfKekyyn: {
      required: helpers.withMessage("郵便番号を入力してください", required),
      max: helpers.withMessage(({ $params }) => `郵便番号は${($params as { max: number }).max}文字以内で入力してください`, maxLength(7)),
    },
    tfKekya1: {
      required: helpers.withMessage("住所 漢字を入力してください", required),
      max: helpers.withMessage(({ $params }) => `住所 漢字は${($params as { max: number }).max}文字以内で入力してください`, maxLength(410)),
    },
    tfKekya2: {
      max: helpers.withMessage(({ $params }) => `建物名は${($params as { max: number }).max}文字以内で入力してください`, maxLength(100)),
    },
    tfKekya3: {
      required: helpers.withMessage("住所 カナを入力してください", required),
      max: helpers.withMessage(({ $params }) => `住所 カナは${($params as { max: number }).max}文字以内で入力してください`, maxLength(410)),
      zenkakuKana: helpers.withMessage("住所 カナは全角カナ・数字・スペース・英字・記号で入力してください", validZenkakuKanaForAddress),
    },
    tfKekytl: {
      max: helpers.withMessage(({ $params }) => `その他電話番号は${($params as { max: number }).max}文字以内で入力してください`, maxLength(13)),
    },
    tfKekyt2: {
      max: helpers.withMessage(({ $params }) => `携帯電話番号は${($params as { max: number }).max}文字以内で入力してください`, maxLength(13)),
    },
  },
}));
